module.exports = __webpack_public_path__ + "static/img/landlord.6a665f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/landlord.svg
// module id = ttAU
// module chunks = 30